module.exports = __webpack_public_path__ + "img/state_of_palestine.a23249e.webp";